
var googleAPI = (function() {

	var googleArray = []; 

	return {
		
		makeIdIframe: function(){
			var text = "";
		    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		    for( var i=0; i < 6; i++ )
		        text += possible.charAt(Math.floor(Math.random() * possible.length));

		    return text;
		},

		checkLogin: function(){

			var urlCheckLogin = '//social.rvsitebuilder.com/google/checkStatusGoogleMaps.php';
			var frameGetStatus = '<iframe id="checkStatusFacebook" src="" width="100%" height="300" style="display:none;"></iframe>';

			$('#frameBody').after(frameGetStatus);
			$('#checkStatusFacebook').attr("src", urlCheckLogin);
			//setTimeout(function(){ $('#checkStatusFacebook').remove(); },5000);

			return true;

		},
		
		openGoogleMaps: function(){
			
			var openerGoogleMaps;
			var fBody =  $('#frameBody').contents();
			var widthframe = "820";
			var heightframe = "500";
			var leftScreen = (screen.width/2)-(widthframe/2);
			var topScreen = (screen.height/2)-(heightframe/2);
			var url = '//social.rvsitebuilder.com/google/googleMapEngine.html';
			$(RVwys.currentiFrame).focus();
			fBody.find('.layoutResize').remove().end();
			
			if(openerGoogleMaps) {
				openerGoogleMaps.focus();
				if (openerGoogleMaps.closed) {
					openerGoogleMaps = window.open(url, 'facebookPhoto', 'height='+heightframe+',width='+widthframe+',toolbar=0,top='+topScreen+',left='+leftScreen);
					openerGoogleMaps.focus();
				}
			} else {
				openerGoogleMaps = window.open(url, 'facebookPhoto', 'height='+heightframe+',width='+widthframe+',toolbar=0,top='+topScreen+',left='+leftScreen);
				openerGoogleMaps.focus();
			}
		
		},
		
		editGoogleMaps: function(attrSrc,iframeID,widthIframe,heightIframe,widthUnit,heighthUnit,getAlign){
			var paramInsert = attrSrc.match(/\?.*/gmi);
			console.log(attrSrc);
			console.log(paramInsert);
			
			var openerGoogleMaps;
			var fBody =  $('#frameBody').contents();
			var widthframe = "820";
			var heightframe = "500";
			var leftScreen = (screen.width/2)-(widthframe/2);
			var topScreen = (screen.height/2)-(heightframe/2);
			var googleMapEdit = 'googleMapEdit.php';
			var url = parent.wex.url.baseUrl.replace('images/','')+'rvwysiwyg/plugins/Google/toolbar/'+googleMapEdit+paramInsert+'&iframeID='+iframeID+'&width='+widthIframe+'&height='+heightIframe+'&widthUnit='+widthUnit+'&heighthUnit='+heighthUnit+'&getAlign='+getAlign;
			
			$(RVwys.currentiFrame).focus();
			fBody.find('.layoutResize').remove().end();

			if(openerGoogleMaps) {
				openerGoogleMaps.focus();
				if (openerGoogleMaps.closed) {
					openerGoogleMaps = window.open(url, 'facebookPhoto', 'height='+heightframe+',width='+widthframe+',toolbar=0,top='+topScreen+',left='+leftScreen);
					openerGoogleMaps.focus();
				}
			} else {
				openerGoogleMaps = window.open(url, 'facebookPhoto', 'height='+heightframe+',width='+widthframe+',toolbar=0,top='+topScreen+',left='+leftScreen);
				openerGoogleMaps.focus();
			}
			
		},
		
		saveEditGoogleMaps: function(getLat,getLng,getInfo,getTypeMaps,frameID,widthIframe,heightIframe,widthUnit,hieghtUnit,getAlign){
			
			var googleMapservice = 'googleMapService.php';
			var paramInsert = '?infoWindows='+ getInfo + '&coordinatesLat='+ getLat +'&coordinatesLng='+ getLng +'&mapType='+ getTypeMaps+'&width='+widthIframe+'&height='+heightIframe;
			var editSrc = parent.wex.url.baseUrl.replace('images/','')+'plugins/Google/toolbar/'+googleMapservice+paramInsert;
			
			$('iframe#'+frameID).attr('src',editSrc);
			$('iframe#'+frameID).parent().css({'width': widthIframe+widthUnit , 'height' : heightIframe+hieghtUnit});
			googleAPI.getAlignIframe(getAlign,frameID,'editMode');
			
		},
		
		getAlignIframe: function(getAlign,frameID,statusMode){
			
			if(statusMode == 'saveMode'){
				 var fBody =  $('#frameBody').contents(); 
				 var divParent = fBody.find('iframe#'+frameID).parent();
			}else{
				 var divParent = $('iframe#'+frameID).parent();
			}
		
		
			switch(getAlign){
				case "left":
					if(divParent.parent().prop('tagName') == 'CENTER'){
						divParent.unwrap();
					}
					if(divParent.next().attr('class') != 'clear' && divParent.next().prop('tagName') != 'DIV'){
						divParent.after('<div class="clear"></div><br>');
					}
					divParent.css('float','left');
					break;
				case "center":
					if(divParent.css('float') == 'left' || divParent.css('float') == 'right'){
						divParent.css('float','');
						if(divParent.next().attr('class') == 'clear' && divParent.next().prop('tagName') == 'DIV'){
							divParent.next().remove();
						}
					}
					divParent.wrap("<center></center>");
					divParent.after('<br>');
					break;
				case "right":
					if(divParent.parent().prop('tagName') == 'CENTER'){
						divParent.unwrap();
					}
					if(divParent.next().attr('class') != 'clear' && divParent.next().prop('tagName') != 'DIV'){
						divParent.after('<div class="clear"></div><br>');
					}
					divParent.css('float','right');
					break;
			}
			
		}
		
	}

}());


window.addEventListener("message",function (e) { 
	
	var eData = e.data;

	
	if(eData[1] == "google"){
		
		switch(eData[0]){
		
		case 'openGooglemaps':
			console.log(eData[0]);
			googleAPI.openGoogleMaps();
			break;
		case 'insertGooglemaps':
			//alert(eData[2]);
			var idIframe = googleAPI.makeIdIframe();
			(eData[2][4] == '')? eData[2][4] = 600 : eData[2][4] = eData[2][4];
			(eData[2][5] == '')? eData[2][5] = 600 : eData[2][5] = eData[2][5];
			
			var googleMapservice = 'googleMapService.php';
			var paramInsert = '?infoWindows='+ eData[2][2] + '&coordinatesLat='+ eData[2][0] +'&coordinatesLng='+ eData[2][1] +'&mapType='+ eData[2][3];
			var wrapPasteHtml = '<div id="pasteElement"><div class="iframeHolder" style="width:'+eData[2][4]+eData[2][6]+';height:'+eData[2][5]+eData[2][7]+'"><iframe width="100%" height="100%" frameborder="0" id="'+idIframe+'" style="pointer-events:none;border:0;" class="serviceGoogleMaps" src="'+parent.wex.url.baseUrl.replace('images/','')+'plugins/Google/toolbar/'+googleMapservice+paramInsert+'"></div></div>';
			RVwys.insertHTML(wrapPasteHtml);
			fBody.find('#pasteElement').contents().unwrap();
			
			googleAPI.getAlignIframe(eData[2][8],idIframe,'saveMode');
			break;
		default:
			console.log('Not Defined');
		}
		
	}
}, false);
